import { ConsoleLogger } from "@aws-amplify/core";
import React, { useContext, useState } from "react";
import { AccountContext } from "../../User/Account";

const ForgotPassword = () => {
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const [verificationCode, setVerificationCode] = useState("");

	const [verifyScreen, setVerifyScreen] = useState(false);

	const { UserForgotPassword, Auth, ConfirmPassword } =
		useContext(AccountContext);

	const RequestPasswordReset = async (e: React.FormEvent<EventTarget>) => {
		e.preventDefault();
		console.log("Request password reset");
		UserForgotPassword(username)
			.then((data: any) => {
				console.log("You requested a password code!");
				console.log(data);
				setVerifyScreen(true);
			})
			.catch((err: any) => {
				console.log("Cannot request password reset :(");
				console.log(err);
			});
	};

	const VerifyNewPassword = async (e: React.FormEvent<EventTarget>) => {
		e.preventDefault();
		console.log("Verifying new password:");
		console.log(username, password, verificationCode);
		ConfirmPassword(username, verificationCode, password)
			.then((data: any) => {
				console.log("You requested a password code!");
				console.log(data);
				if (data === "SUCCESS") {
					Auth(username, password)
					.then((data: any) => {
						console.log("Logged In!", data);
					})
					.catch((err: any) => {
						console.error("Failed to Login", err);
					});
				}
			})
			.catch((err: any) => {
				console.log("Cannot request password reset :(");
				console.log(err);
			});
	};

	return (
		<div>
			{!verifyScreen ? (
				<div>
					<div className="title">
						<h1>Reset Password</h1>
					</div>
					<form>
						<div className="form-group mt-3">
							<label htmlFor="userResetPassword_first">
								Please enter the username of the account you
								would like to reset the password. You will
								received an email.
							</label>
							<input
								onChange={(e) => setUsername(e.target.value)}
								type="text"
								className="form-control mt-3"
								id="userResetPassword_first"
								aria-describedby="resetPasswordAria_first"
								placeholder="Username"
							/>
						</div>
					</form>
					<div className="footer">
						<div
							className="btn btn-danger mt-3"
							onClick={RequestPasswordReset}
						>
							Reset Password
						</div>
					</div>
				</div>
			) : (
				<div>
					<div className="title">
						<h1>Reset Password</h1>
					</div>
					<form>
						<div className="form-group mt-3">
							<label htmlFor="userResetPassword_second">
								Username
							</label>
							<input
								onChange={(e) => setUsername(e.target.value)}
								type="text"
								className="form-control mb-3"
								id="userResetPassword_second"
								aria-describedby="resetPasswordAria_second"
								placeholder="Username"
							/>

							<label htmlFor="passwordResetPassword">
								New Password
							</label>
							<input
								onChange={(e) => setPassword(e.target.value)}
								type="Password"
								className="form-control mb-3"
								id="passwordResetPassword"
								aria-describedby="passwordAria"
								placeholder="Password"
							/>

							<label htmlFor="codeResetPassword">
								Verification Code
							</label>
							<input
								onChange={(e) =>
									setVerificationCode(e.target.value)
								}
								type="text"
								className="form-control mb-3"
								id="codeResetPassword"
								aria-describedby="codePasswordAria"
								placeholder="Verification Code"
							/>
						</div>
					</form>
					<div className="footer">
						<div
							className={`btn btn-danger mt-3 ${(username !== "" && password !== "" && verificationCode !== "") ? "" : "disabled"}`}
							onClick={VerifyNewPassword}
						>
							Verify Account
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default ForgotPassword;
